import React from 'react';
import './PoweredByTrAingle.css';

function PoweredByTrAingle({ className = '' }) {
  return (
    <span className={`powered-by-traingle ${className}`.trim()}>
      Powered by <strong>TrAingle</strong>
    </span>
  );
}

export default PoweredByTrAingle;
